var map = {
	"./KsxLogo.svg": 790,
	"./arrow-down-blue.svg": 791,
	"./arrow-down-grey.svg": 792,
	"./arrow-right-white.png": 793,
	"./arrow-right.svg": 794,
	"./blue-loader.svg": 795,
	"./circle-grey.svg": 796,
	"./circle.svg": 797,
	"./coinbaseWalletIcon.svg": 278,
	"./dropdown-blue.svg": 798,
	"./dropdown.svg": 216,
	"./dropup-blue.svg": 799,
	"./ethereum-logo.png": 800,
	"./fortmaticIcon.png": 279,
	"./header_ksx.svg": 801,
	"./header_pcx.svg": 802,
	"./icon.xbtc.svg": 433,
	"./icon_BEVM.svg": 803,
	"./icon_add.svg": 434,
	"./icon_add_liquidity.webp": 435,
	"./icon_arrow_down.webp": 436,
	"./icon_arrow_left.svg": 804,
	"./icon_arrow_up.webp": 437,
	"./icon_bridge_message.svg": 805,
	"./icon_bsc_busd.png": 806,
	"./icon_bsc_logo.png": 807,
	"./icon_bsc_usdc.png": 808,
	"./icon_bsc_usdt.png": 809,
	"./icon_chainx.svg": 810,
	"./icon_clock.webp": 811,
	"./icon_earn_empty.webp": 812,
	"./icon_empty.svg": 813,
	"./icon_kusama.svg": 814,
	"./icon_loading.svg": 815,
	"./icon_metamask.svg": 284,
	"./icon_minix.svg": 816,
	"./icon_minix_chain.svg": 817,
	"./icon_next.svg": 818,
	"./icon_polka_logo.svg": 819,
	"./icon_previous.svg": 820,
	"./icon_reduce.svg": 438,
	"./icon_rise.svg": 439,
	"./icon_sbtc.svg": 821,
	"./icon_sherpax_logo.webp": 822,
	"./icon_so.svg": 823,
	"./icon_success.svg": 440,
	"./icon_tip.svg": 441,
	"./icon_tip_dark.svg": 196,
	"./icon_unknown.svg": 824,
	"./icon_warming.svg": 169,
	"./img_errors.svg": 442,
	"./link.svg": 825,
	"./magnifying-glass.svg": 826,
	"./menu.svg": 827,
	"./metamask.png": 443,
	"./plus-blue.svg": 828,
	"./plus-grey.svg": 829,
	"./portisIcon.png": 280,
	"./question-mark.svg": 830,
	"./question.svg": 831,
	"./spinner.svg": 832,
	"./token-list/lists-dark.png": 833,
	"./token-list/lists-light.png": 834,
	"./trustWallet.png": 835,
	"./walletConnectIcon.svg": 281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 392;